import { Pipe, PipeTransform } from '@angular/core';
import * as Utils from '@shared/core/utils';

@Pipe({ name: 'appDayName' })
export class DayNamePipe implements PipeTransform {
    transform(value: number): string {
        if (!Number.isInteger(+value)) return `Invalid value: ${value}`;
        return Utils.Dates.getDayName(value);
    }
}
